import Base from './Base';
import Source from '../models/Source';

export default class Sources extends Base {
    get models() {
        const collection = this.data.map(item => new Source(item));
        collection.collection = this;

        return collection;
    }
}
